module.exports = __webpack_public_path__ + "static/media/vlaanderen-medegefinancierd-door-de-eu-horizontal.12dda83a.png";